"use client";
import { useStoreContext } from "../../store/provider";
import { toast } from "react-toastify";

export function usePaystackPayment({
  amount,
  label,
  handleSuccess,
  onPaymentCancelled,
}: {
  amount: number;
  label: string;
  handleSuccess: (res: { reference: string }) => Promise<void>;
  onPaymentCancelled?: () => void;
}) {
  const { user } = useStoreContext();
  const handlePaystackPayment = async (
    reference: string,
    payload?: {
      amount: number;
      label: string;
    },
  ) => {
    if (typeof window === "undefined") return;

    const config = {
      email: user?.email?.email ?? "",
      amount: payload?.amount ?? amount,
      key: process.env.NEXT_PUBLIC_PAYSTACK_PUBLIC_KEY,
      reference: reference,
      currency: "NGN",
      label: payload?.label ?? label,
      firstname: user?.firstName,
      lastname: user?.lastName,
    };

    const onSuccess = (res: { reference: string }) => handleSuccess(res);
    const onClose = () => {
      toast.error("Payment cancelled!");

      if (onPaymentCancelled) {
        onPaymentCancelled();
      }
    };

    const { default: PaystackPop } = await import("@paystack/inline-js");
    const paystack = new PaystackPop();
    paystack.newTransaction({
      ...config,
      onSuccess,
      onClose,
    });
    paystack.open();
  };

  return {
    handlePaystackPayment,
  };
}
